import { useEffect, useState } from "react";
import useApi from "./useApi";

interface MakeStatus {
  configured: boolean;
  displayName?: string;
}

export default function useMakeStatus() {
  const [status, setStatus] = useState<MakeStatus | null>(null);
  const [loading, setLoading] = useState(true);
  const api = useApi();

  useEffect(() => {
    async function fetch() {
      setLoading(true);
      try {
        const resp = await api.messaging.get("Make/config");
        const data = resp.ok ? await resp.json() : null;
        setStatus({ configured: data?.configured ?? false, displayName: data?.displayName });
      } catch {
        setStatus({ configured: false });
      } finally {
        setLoading(false);
      }
    }
    fetch();
  }, [api.messaging]);

  return { status, loading };
}
